export default [
    {
        path: "/voucher/canteen/purchase",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/List.vue"),
        name: "voucher.canteen.purchase",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/purchase/create",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/Create.vue"),
        name: "voucher.canteen.purchase.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/purchase-multi-product/create",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/MultiCreate.vue"),
        name: "voucher.canteen.purchase.multi.product",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/purchase/pending",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/Pending.vue"),
        name: "voucher.canteen.purchase.pending",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales-return/create",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/SalesReturn.vue"),
        name: "voucher.canteen.sales.return.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/purchase/:id/edit",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/Edit.vue"),
        name: "voucher.canteen.purchase.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/purchase/:id/view",
        component: () => import("@/App/Canteen/Voucher/Purchase/Components/View.vue"),
        name: "voucher.canteen.purchase.view",
        meta: {
            requiresAuth: true,
        },
    },
];
